import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import { RouteChildrenProps } from 'react-router';
import { ConsumerRoutes, Routes } from 'src/shared/Routes';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { StringParam, useQueryParam } from 'use-query-params';
import { ExploreTabNames } from '../../dish-first/explore/ExplorePage/consts';
import { Footer } from './Footer';

interface IProps {
  location: RouteChildrenProps['location'];
  history: RouteChildrenProps['history'];
  backgroundRef: React.RefObject<HTMLDivElement>;
}

const ConsumerFooterWrapper: React.FC<IProps> = (props) => {
  const isOnExplorePage = locationInRoutes(props.location, [Routes.CONSUMER_EXPLORE]);
  const [tab] = useQueryParam(QueryParams.TAB, StringParam);
  const isOnExploreWSSTab = isOnExplorePage && tab === ExploreTabNames.ShefService;

  const hideFooter =
    locationInRoutes(props.location, [
      Routes.CONSUMER_ORDER_FINALIZE,
      Routes.CONSUMER_ORDER_CART,
      Routes.CONSUMER_ORDER_EDIT_CART,
      Routes.CONSUMER_SUBSCRIPTION_WIZARD_PAGE,
      Routes.CONSUMER_SUBSCRIPTION_RECEIPT,
      Routes.WAITLIST_ACTIONS,
      Routes.WAITLIST_HOME,
      Routes.CONSUMER_MEAL_PLANS,
      Routes.CONSUMER_MEAL_PLANS_CHECKOUT,
      Routes.CONSUMER_MEAL_PLANS_EDIT,
      Routes.CONSUMER_MEAL_PLANS_PREFERENCES,
      Routes.CONSUMER_MEAL_PLANS_CHECKOUT,
      ConsumerRoutes.CONSUMER_MEAL_PLANS_MANAGE_SERVINGS,
      ConsumerRoutes.CONSUMER_MEAL_PLANS_MANAGE_SCHEDULE,
    ]) || isOnExploreWSSTab;

  return hideFooter ? null : <Footer />;
};

export default ConsumerFooterWrapper;
